<template>
  <table class="table">
    <tbody>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2"><strong>NIT:</strong></h6>
          {{ clientData.nit }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.name') }}:</strong>
          </h6>
          {{ clientData.name }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.phone') }}:</strong>
          </h6>
          <template v-if="isSet(clientData.phone)">
            {{ clientData.phone }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.email') }}:</strong>
          </h6>
          <template v-if="isSet(clientData.email)">
            {{ clientData.email }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.comercial_name') }}:</strong>
          </h6>
          <template v-if="isSet(clientData.tradename)">
            {{ clientData.tradename }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="custom-margin-h6-table">
            <strong>{{ $t('common_words.associated_companies') }}:</strong>
          </h6>
          <span
            v-for="(business, index) in clientData.business_names"
            :key="index"
          >
            <el-tag type="info">{{ business }}</el-tag>
          </span>
          <el-tag type="warning" v-if="clientData.business_names.length == 0">{{
            $t('common_words.no_associated_companies')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.website') }}:</strong>
          </h6>
          <template v-if="isSet(clientData.web_site)">
            {{ clientData.web_site }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.economic_activity') }}:</strong>
          </h6>
          <template v-if="isSet(clientData.comercial_activity)">
            {{ clientData.comercial_activity }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.address') }}:</strong>
          </h6>
          <template v-if="isSet(clientData.address)">
            {{ clientData.address }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.country') }}:</strong>
          </h6>
          {{ clientData.country }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.state') }}:</strong>
          </h6>
          {{ clientData.state }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.city') }}:</strong>
          </h6>
          {{ clientData.city }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { isset } from 'src/util/Util.js';

export default {
  name: 'client-details-table',
  props: {
    clientData: {
      type: Object,
      default: null,
    },
  },

  methods: {
    isSet(data) {
      return isset(data);
    },
  },
};
</script>
